import addError from '../../../utils/error.jsx';

export function request(query, collection = 'all') {
    return {
        type: 'STAFF_QUERY_REQUEST',
        collection,
        query
    };
}

export function error(errors, collection = 'all') {
    addError(errors);
    return {
        type: 'STAFF_QUERY_ERROR',
        collection,
        errors
    };
}

export function finish(staff, collection = 'all') {
    return {
        type: 'STAFF_QUERY_FINISH',
        collection,
        staff
    };
}
